import { render, staticRenderFns } from "./orderMng.vue?vue&type=template&id=481df435&"
import script from "./orderMng.vue?vue&type=script&lang=js&"
export * from "./orderMng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports